function isFormValid(formId: string) {
  const form = document.getElementById(formId);

  if (!form || !(form instanceof HTMLFormElement)) {
    return false;
  }

  if (form.checkValidity() === false) {
    // Global window.event? Would be nicer to do with react
    event.preventDefault();
    event.stopPropagation();
    return false;
  }

  return true;
}

export default isFormValid;
